module.exports = __webpack_public_path__ + "static/media/WhipAround_ios_3_preview.8cfd6f89.jpg";